import { get } from 'lodash';
import * as React from 'react';
import NotosService from '../../../../classes/notos.service';
import './CartTotals.css';

const CartTotals = ({ totals, sidebar, currencyLabel }) => {
    const adjustmentTotal = get(totals, 'attributes.adjustment_total', NotosService.DEFAULT_PRICE);
    const shipmentTotal = get(totals, 'attributes.shipment_total', NotosService.DEFAULT_PRICE);
    const itemTotal = get(totals, 'attributes.item_total', NotosService.DEFAULT_PRICE);
    const total = get(totals, 'attributes.total', NotosService.DEFAULT_PRICE);
    const pack = get(totals, 'attributes.packing_total', NotosService.DEFAULT_PRICE);
    const currency = currencyLabel === "eur" ? NotosService.EURO_CURRENCY : NotosService.CURRENCY
    return (
        <div>
            {sidebar ? (
                <div className="col-12">
                    <hr />
                </div>
            ) : null}
            <div className={`${sidebar ? 'col-12' : 'col-md-5 offset-md-7'} cart-totals`}>
                <p className="sum-row">
                    <span>Междинна сума</span>
                    <span>
                        {itemTotal} {currency}
                    </span>
                </p>
                <p className="sum-row">
                    <span>Доставка</span>
                    <span>
                        {shipmentTotal} {currency}
                    </span>
                </p>
                {/* @ ts-ignore */}
                {pack !== NotosService.DEFAULT_PRICE ? (
                    <p className="sum-row">
                        <span>Опаковка</span>
                        <span>
                            {pack} {currency}
                        </span>
                    </p>
                ) : null}
                {/* <p className="sum-text">Добавете продукти за още 6.00 лв. за безплатна доставка.</p> */}
                <p className="sum-row">
                    <span>Отстъпка</span>
                    <span>
                        {adjustmentTotal} {currency}
                    </span>
                </p>
            </div>
            <div className="col-12">
                <hr />
            </div>
            {/* {'col-12 за сайдбара'} */}
            <div className={`${sidebar ? 'col-12' : 'col-md-5 offset-md-7'} cart-grand-total`}>
                <p className="sum-row">
                    <span>Обща сума</span>
                    <span>
                        {total} {currency}
                    </span>
                </p>
            </div>
            <div className="col-12 mb_20">
                <hr />
            </div>
        </div>
    );
};

export default CartTotals;



// WEBPACK FOOTER //
// ./src/components/Orders/OrdersList/OrderDetails/CartTotals.js